module.exports = __webpack_public_path__ + "static/media/c1.f404f71f.jpg";